<script>
import axios from "axios";
import SmartSocket from "@/../submodules/vue-base/js/SmartSocket";

export default {
    name: 'Events',

    data() {
        return {

			socket: null,

			eventDispatchMap: {

				admissionFieldUpdate: "admissionFieldUpdateEvent",
				admissionUpdate: "admissionUpdateEvent",
				admissionLabUpdate: "admissionLabUpdateEvent",
				admissionDelete: "admissionDeleteEvent",
				admissionArchive: "admissionArchiveEvent",

				listDelete: "listDeleteEvent",
				listUpdate: "listUpdateEvent",
				listPermissions: "listPermissionsEvent",
				sosListsUpdate: "sosListsUpdateEvent",
				userListsUpdate: "userListsUpdate",

				editingState: "editingStateEvent",
				userDisconnect: "userDisconnectEvent",

				sectionUpdate: "sectionEvent",
				rankChange: "rankChangeEvent",

				sessions: "sessionChangeEvent",

				hardwareMismatch: "hardwareMismatchEvent",
				licenseActivationNeeded: "licenseActivationNeededEvent"
			}
        }
    },
    methods: {
        initializeEvents() {
            var temp = this;


			var connection = "wss";

			if(location.protocol != 'https:'){
				connection = "ws";
			}
			
			this.socket = new SmartSocket(
				connection + "://" + window.location.host + "/api/1/events",
				function(message){
					var event = JSON.parse(message.data);

					temp.$store.dispatch(temp.eventDispatchMap[event.key],event.val);

				}
			);

      
        },
        
    }
}
</script>
